import { render, staticRenderFns } from "./supplier-view.vue?vue&type=template&id=90a681de&scoped=true"
import script from "./supplier-view.vue?vue&type=script&lang=js"
export * from "./supplier-view.vue?vue&type=script&lang=js"
import style0 from "./supplier-view.vue?vue&type=style&index=0&id=90a681de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a681de",
  null
  
)

export default component.exports